/**
 * r7-25 — guarda da tela "sem plano" (`/sem-plano`), fora do DashboardLayout (sem menu:
 * nao ha para onde ir sem plano).
 *
 * Entra quem esta logado e sem plano (`plan_access.has_access === false` ou 402 ja
 * recebido). Quem tem plano e mandado para a home do papel; aceite legal pendente vem
 * antes de tudo.
 */
import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { LoadingOverlay } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'
import { useThemeInit } from '@/stores/uiStore'
import { clearSubscriptionBlock, useSubscriptionBlocked } from '@/lib/subscriptionBlock'
import { needsPlan } from '@/lib/planFeatures'
import { homePathForRole } from './onboardingAccess'

export function NoPlanGate() {
  const { user, isAuthenticated, isLoading, checkAuth } = useAuthStore()
  const blocked = useSubscriptionBlocked()

  useThemeInit()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  const hasPlan = !!user && !needsPlan(user)

  // O 402 foi um sinal de um momento; se o `/auth/me` fresco diz que ha plano (ex.:
  // o admin acabou de vincular), o sinal velho nao pode prender o aluno aqui.
  useEffect(() => {
    if (hasPlan && blocked && !isLoading) clearSubscriptionBlock()
  }, [hasPlan, blocked, isLoading])

  if (isLoading && !user) {
    return <LoadingOverlay message="Carregando..." />
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  if (hasPlan && !isLoading) {
    return <Navigate to={homePathForRole(user)} replace />
  }

  return <Outlet />
}
